import { api } from '../lib/api-client.js';

export type SavedViewScope = 'work_orders' | 'violations';

export interface SavedView {
  id: string;
  userId: string;
  orgId: string | null;
  scope: SavedViewScope;
  name: string;
  filters: Record<string, unknown>;
  sort: Record<string, unknown>;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export async function listSavedViews(scope: SavedViewScope): Promise<SavedView[]> {
  const res = await api<{ views: SavedView[] }>(
    `/saved-views?scope=${encodeURIComponent(scope)}`,
  );
  return res.views;
}

export async function createSavedView(input: {
  scope: SavedViewScope;
  name: string;
  filters: Record<string, unknown>;
  sort?: Record<string, unknown>;
  isDefault?: boolean;
}): Promise<SavedView> {
  const res = await api<{ view: SavedView }>('/saved-views', {
    method: 'POST',
    body: { ...input, sort: input.sort ?? {} },
  });
  return res.view;
}

export async function updateSavedView(
  id: string,
  input: Partial<Pick<SavedView, 'name' | 'filters' | 'sort' | 'isDefault'>>,
): Promise<SavedView> {
  const res = await api<{ view: SavedView }>(`/saved-views/${id}`, {
    method: 'PATCH',
    body: input,
  });
  return res.view;
}

export async function deleteSavedView(id: string): Promise<void> {
  await api(`/saved-views/${id}`, { method: 'DELETE' });
}
